export enum ControlStatus {
  Active = 1,
  Inactive = 2,
}
export enum InfrastructureType {
  Harbor = 1,
  Airport,
  PowerPlants,
  Highway,
  Rail,
  NaturalGasPipeline,
  Office,
  Hotel,
}

export enum TypeMarker {
  SEZ = 1,
  Infrastructure,
}

export enum GalleryType {
  Video = 'video',
  Image = 'image',
}

export enum DownloadFormType {
  Report = 1,
  Document,
}
